<template>
  <transition
    name="list"
  >
    <div
      class="owal-list__container"
    >
      <slot>
        <div
          v-if="item"
          class="owal-list__content_text"
        >
          {{ this.item.title }}
        </div>
        <owal-list-row-accessory
          class="owal-list__accessory"
          :type="accessoryType"
        />
      </slot>
    </div>
  </transition>
</template>

<script>
/**
 * OwalListRow.vue
 *
 * @description A row in an OwalList.
 *
 * @prop {Object} item The content of the row.
 *
 */

import OwalListRowAccessory from './OwalListRowAccessory'
import { OwalListRowAccessoryType } from '../model'

export default {
  name: 'OwalListRow',
  components: {
    OwalListRowAccessory,
  },
  props: {
    item: {
      type: Object,
    },
    accessoryType: {
      default: () => OwalListRowAccessoryType.NONE,
    },
  },
}
</script>

<style scoped>
.owal-list__container {
  display: flex;
  flex-direction: row;
  align-items: center;
  align-content: center;
  justify-content: space-between;
  border-bottom: 1px solid #C0CCDA;
  padding: 0.5rem;
}

.owal-list__accessory {
  display: flex;
  flex-direction: row;
  align-items: center;
  align-content: center;
  justify-content: center;
  margin-left: 0.5rem;
  flex-shrink: 0;
  height: 100%;
}

.owal-list__row-instance {
  transition: opacity 200ms linear;
  opacity: 1;
}

</style>
